/**
 *  统一下载弹窗
 * ============ ======= ======================================================
 * 2022/08/12      1.0      First version   BY.GSM   来源.\Bill\Bill.js
 * 2022/09/14      2.0     Second version   BY.FJJ   统一调用组件
 *
 * @copyright 2021-2022, all rights reserved. Essa.cn
 * */
import React  from 'react'
import {Modal, Radio,Button,message,Checkbox} from 'antd';
import ShipperManagementAction from "../../../ShipperManagement.action";
import Lang from "@components/Lang/Lang";

export default class DownloadBtnModal extends React.Component{
    constructor(props) {
        super(props);
        this.state = {
            downloadLang:'ru',
            visible:false,
            loadingDownload:false,
            statuInfo:{},
            selectOption: [
                {disabled:false,code:'load',id: 'ZhuangXiangDan', title: '装箱单',statusName:'conLoadContainerOrderStatus',ordertype:'con_load_container_order'},
                {disabled:false,code:'trucking',id: 'SuiCheDan', title: '随车单',statusName:'conTruckingOrderStatus',ordertype:'con_trucking_order'},
                {disabled:false,code:'freight',id: 'YunFeiDan', title: '运费单',statusName:'conFreightOrderStatus',ordertype:'con_freight_order'},
                {disabled:false,code:'freight_price',id: 'YunFeiBaoJiaDan', title: '运费报价单', ordertype:'con_freight_quote_order'},
                {disabled:false,code:'freight_pay',id: 'YunFeiHuiKuanDan', title: '运费汇款单',statusName:'conFreightPayOrderStatus',ordertype:'con_freight_pay_order'},
                {disabled:false,code:'letter',id: 'HaiGuanXinHan', title: '海关信函',statusName:'conCustomsLetterStatus',ordertype:'con_customs_letter'},
                {disabled:false,code:'price',id: 'JiaGeBiao', title: '价格表',statusName:'conPriceOrderStatus',ordertype:'con_price_order'},
                {disabled:false,code:'goods',id: 'ShangPinBiao', title: '商品表',statusName:'conGoodsOrderStatus',ordertype:'con_goods_order'},
            ],
            orderTypeList:[]
        }
    }
    /**
     * 打开下载链接
     */
    openDownLoad(id,downloadLang,downloadUrl){
        let {orderTypeList} = this.state;
        let {orderInfo} = this.props;


        if(!orderTypeList.length){
            message.warning(Lang({id: "WangLuoGuZhangHuQingXuanZeXuYaoXiaZaiDeBaoJiaDanoZheXiTon",default:'请选择需要下载的单据'}));
            return;
        }
        this.setState({
            visible:false,
        },()=>{
            //http://localhost:3000/act/shipperManagement/downloading?id=77&type=QualityPic
            ShipperManagementAction.downloadPic({
                containerId:orderInfo.containerId,
                downloadType:this.props.type === 'pdf'?'pdf':'excel',
                isReload:1,
                lang:this.state.downloadLang,
                orderTypeList:this.state.orderTypeList
            },'OrderMsg').then(res => {

                if(res.success && res.valid){
                    this.setState({
                        visible:false,
                    })
                }

                if(res.model && res.model.viewName){
                    window.open(res.model.viewName);
                }else{
                    window.open(`/act/shipperManagement/downloading?id=${orderInfo.containerId}&downloadType=${this.props.type === 'pdf'?'pdf':'excel'}&orderTypeList=${orderTypeList}&lang=${downloadLang}&type=OrderMsg`)
                }
            })
        });
    }

    /**
     * 查看各个报表状态
     * * */
     getDetailStatus(){
        const postData = {
            containerId:this.props.orderInfo && this.props.orderInfo.containerId,
        }
        ShipperManagementAction.autoFetchAction(postData,'/service/mg/con/report/queryConReportOrderStatus').then(res=>this.handleRes(res.data)).catch(err=>this.handleRes(err));
    }

    /**
     * 设置 信息
     * */
     handleRes(res,){
        const {success,valid} = res;
        if(success&&valid){
            this.setState({
                statuInfo:res.model||{},
            })
        }else{
            if(res.message){
                message.warning(res.message);
            }
        }
    }


    /**
     * 切换语言
     **/
    handleChangeLang(e){
        this.setState({
            downloadLang: e.target.value
        });
    };

    // 修改状态
    changeOrderType(e,data){
        let checked = e.target.checked;
        let {orderTypeList} = this.state
        if(checked){
            orderTypeList.push(data.ordertype)
        }else{
            let atIndex = orderTypeList.findIndex(item => item == data.ordertype);
            orderTypeList.splice(atIndex,1);
        }

        this.setState({
            orderTypeList:orderTypeList
        })
    }

    /**
     * 下载
     **/
    openDownLoadFlag(flag=false){

        this.getDetailStatus()

        this.setState({
            visible:flag,
            orderTypeList:[],
        })
    }
    componentWillUnmount(){
        this.setState = (state, callback) => {
            return;
        }
    }
    render() {
        const  {title,className, orderInfo,downloadUrl,type} = this.props;
        const {visible,loadingDownload,downloadLang,statuInfo,orderTypeList,selectOption} = this.state;

        if(type != 'pdf'){
            delete selectOption[5];
        }

        return (<>
            <span className={className} onClick={()=>this.openDownLoadFlag(true)}>{title}</span>
            {/*下载*/}
            {visible&&<Modal title={orderInfo.status=='10'&&type=='pdf'?Lang({id:'TiShi',default:'提示'}):title}
                             open={visible}
                             onCancel={()=>this.openDownLoadFlag()}
                             footer={<div>
                                         <Button onClick={()=>this.openDownLoadFlag()}>{Lang({id:'QuXiao',default:'取消'})}</Button>
                                         {
                                            <Button className="margin-left-5" loading={loadingDownload} disabled={!downloadLang}
                                            onClick={this.openDownLoad.bind(this,orderInfo.id,downloadLang,downloadUrl)}>{Lang({id:'queren',default:'确认'})}</Button>
                                         }
                                         
                                     </div>}>
                <Radio.Group value={downloadLang}
                                                                                                                                            onChange={(e)=>this.handleChangeLang(e)}  className='margin-bottom-10'>
                    <Radio.Button value="zh">中文</Radio.Button>
                    <Radio.Button value="en">English</Radio.Button>
                    <Radio.Button value="ru">русский</Radio.Button>
                </Radio.Group>

                {
                    <div>
                        {
                            selectOption.map((item,index) => {
                                return (
                                    <div className={`margin-bottom-10 repert-line ${orderTypeList.indexOf(item.ordertype) == -1?null:'cur'}`}  key={index}>
                                        <Checkbox disabled={(statuInfo[item.statusName]=='0') || (statuInfo[item.statusName]=='10' && type=='pdf')} onChange={(e) => {
                                            this.changeOrderType(e,item)
                                        }}>
                                            {statuInfo[item.statusName]=='10'&&<i className="margin-right-5 ri-todo-line" style={{color:'#CE5650'}}></i>}
                                            {statuInfo[item.statusName]=='20'&&<i className="margin-right-5 ri-checkbox-multiple-line" style={{color:'#1EB071'}}></i>}
                                            {Lang({id:item.id,default:item.title})}</Checkbox>
                                    </div>
                                )
                            })
                        }
                    </div>

                }
                
            </Modal>}

        </>)
    }
}
